import Fetch from '@/api';
import VM from '../../main';
import payDialog from '@/components/global/payDialog';
import Constant, { CHAIN_TYPE } from '@/lib/constant';
import { hasPermission } from '@/util';
import { Loading, Message } from 'element-ui';

function paySuccess(payBox, isChain) {
  payBox.close();
  const { MONOMER } = CHAIN_TYPE;
  // 如果是单体只有门店账户，跳转门店账户
  if (isChain === MONOMER) return VM.$router.push('/shopAccount');
  // 如果是连锁且只要有公司负责人就跳转续费
  if (hasPermission([Constant.RoleList.a])) return VM.$router.push('/servicePackage');
  // 如果是连锁且只要有店长就跳转门店账户
  if (hasPermission([Constant.RoleList.d])) return VM.$router.push('/shopAccount');
}
const state = {
  renewalOrderEntrance: false,
  paySuccessJump: false // 是否是支付成功后自动跳转，用来做续费信息页面是否需要弹二次拦截框
};
const mutations = {
  SET_RENEWAL_ORDER_ENTRANCE(state, renewalOrderEntrance) {
    state.renewalOrderEntrance = renewalOrderEntrance;
  },
  SET_PAY_SUCCESS_JUMP(state, data) {
    state.paySuccessJump = data;
  }
};
const actions = {
  async hasRenewalOrderEntrance({ commit }) {
    const res = await Fetch.hasRenewalOrderEntrance();
    commit('SET_RENEWAL_ORDER_ENTRANCE', res.showEntrance);
  },
  async submitRenewalOrder({ commit }, params) {
    const { prefixes } = params;
    delete params.prefixes;
    const res = await Fetch.submitRenewalOrder(params);
    VM.$router.push(`/${prefixes}_renewalInfo/${res.id}`);
  },
  async hasUnpaidOrder({ commit }, prefixes) {
    console.log('prefixes', prefixes);
    const res = await Fetch.hasUnpaidOrder();
    const { hasUnpaidOrder, id } = res;
    if (hasUnpaidOrder) {
      VM.$confirm('你有一笔待支付订单，是否继续？', '支付提示', {
        confirmButtonText: '继续支付',
        cancelButtonText: '取消支付',
        distinguishCancelAndClose: true,
        customClass: 'confirm',
        center: true
      })
        .then(() => {
          VM.$router.push(`/${prefixes}_renewalInfo/${id}`);
        })
        .catch(action => {
          if (action === 'cancel') {
            Fetch.payCancel({ id });
          }
        });
    }
  },
  onPaySuccessJump({ commit }, data) {
    commit('SET_PAY_SUCCESS_JUMP', data);
  },
  async onPay({ commit, rootState }, params) {
    const orderInfo = await Fetch.paySubmit(params);
    const loadingService = Loading.service({
      text: '正在努力加载中....',
      background: 'rgba(0, 0, 0, 0)'
    });
    try {
      const { tradeNo = '', countdown, payPrice } = orderInfo;
      const { default: ZYPay } = await import(
        /* webpackChunkName:'zyPay' */ /* webpackPreload: true */ '@zyf2e/checkout-sdk'
      );
      await ZYPay.init({
        bizId: 'DRUGSTORE_RENEW',
        bizSource: 'DRUGSTORE_RENEW',
        baseURL: Util.getGwRoot,
        needLogin: false
      });
      const { alipay, wechat } = await ZYPay.getPayQRCode(tradeNo);
      const payBox = payDialog({
        tradeNo,
        aliPayString: alipay,
        weChatPayString: wechat,
        countdown,
        payPrice,
        onPaySuccess: () => {},
        onConfirmPayCompleted: () => {
          commit('SET_PAY_SUCCESS_JUMP', true);
          paySuccess(payBox, rootState.global.isChain);
        }
      });
      loadingService.close();
      payBox.show();
    } catch (error) {
      loadingService.close();
      const { message = '支付异常，请返回重试 ' } = error || {};
      Message.error(message);
    }
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
